import { lazy } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ConfirmationGatekeeper from './ConfirmationGatekeeper';

const GeneralLanding = lazy(() => import('../containers/General/General'));
const HomeLoanLanding = lazy(() => import('../containers/HomeLoan/HomeLoan'));
const PersonalLoanLanding = lazy(() => import('../containers/PersonalLoan/PersonalLoan'));
const HardshipLanding = lazy(() => import('../containers/Hardship/Hardship'));

const HOME_LOAN_ALLOWED_SUBPATHS = ['apply', 'lender-enquiry'];

export default function LandingGatekeeper() {

    const params = useParams();

    const base = params.enquiryFormType;   // 'home-loan'
    const rest = params['*'];              // 'apply' | undefined

    const enquiryFormType =
        rest && rest.length > 0
            ? `${base}/${rest.split('/')[0]}`
            : base;
    const hasSplat = Object.prototype.hasOwnProperty.call(params, '*');
    const subPath = hasSplat ? params['*'] : undefined;
    const segments = subPath?subPath.split('/'):"";
   
    
    if (!enquiryFormType) {
        return <Navigate to="/404" replace />;
    }
    if ((segments.length > 0 && ((segments[0] =='confirmation') || segments[segments.length - 1] == 'confirmation'))) {
        return <ConfirmationGatekeeper />;
    }

    //  HOME LOAN
    if (enquiryFormType.includes('home-loan') ) {
        // /home-loan-->OK
        if (!hasSplat || subPath === undefined || subPath === '') {
            return <HomeLoanLanding />;
        }

        // /home-loan/apply OR /home-loan/lender-enquiry -->OK
        if (HOME_LOAN_ALLOWED_SUBPATHS.includes(subPath)) {
            return <HomeLoanLanding />;
        }
       
        // Anything else --> 404
        return <Navigate to="/404" replace />;
    }

    // Other enquiry types must NOT have subpaths
    if (hasSplat && subPath) {
        return <Navigate to="/404" replace />;
    }

    switch (enquiryFormType) {
        case 'general':
            return <GeneralLanding />;

        case 'personal-loan':
            return <PersonalLoanLanding />;

        case 'hardship':
            return <HardshipLanding />;

        case 'financial-planning':
            return <Navigate to="/general" replace />;

        default :
        return <Navigate to="/404" replace />;
       
    }
}
